import {
        GETHRTRAININGHISTORYBYID,
        GETHRTRAININGHISTORYALLDETAILS,
        GETHRTRAININGHISTORY,
        CREATEHRTRAININGHISTORY,
        UPDATEHRTRAININGHISTORY,
        DELETEHRTRAININGHISTORY,

        INITIATELOANHRPAYOUT,
        GET_HR_STAFF_LOAN_REQUESTS,
        GET_HR_STAFF_LOAN_REQUEST_DETAILS,

        GETHRRECRUITMENTINFOHISTORYALLDETAILS,
        GETHRRECRUITMENTSTAGESALLDETAILS,

        GETHRRECRUITMENTINFOBYID,
        GETHRRECRUITMENTINFOHISTORYBYID,
        GETHRRECRUITMENTSTAGESBYID,
        CLEAR_HR_SETUPACL,
        CLEAR_HRINFOHISTORY,
        CLEAR_HR_RECPIPELINE,
        CLEAR_HRINFO,
        GETHRSETUPACLLIST,
        CREATEHRSETUPACLLIST,
        UPDATEHRSETUPACLLIST,
        DELETEHRSETUPACLLIST,
        GETHRLOANDOCUMENTS,
        CREATEHRLOANDOCUMENTS,
        UPDATEHRLOANDOCUMENTS,
        DELETEHRLOANDOCUMENTS,
        GETHRLOANPOLICYINFOHISTORY,
        CREATEHRLOANPOLICYINFOHISTORY,
        UPDATEHRLOANPOLICYINFOHISTORY,
        DELETEHRLOANPOLICYINFOHISTORY,
        SENDHRSMS,
        CREATEHRPAYROLLLOANREPAYMANUAL,
        CREATEHRPAYROLLLOANREPAYPAYROLL,
        CREATEHRPAYROLLLOANPREPAYFULL,
        CREATEHRPAYROLLLOANPREPAYPPARTIAL,
        CREATEHRPAYROLLLOANADDONINTERESTLOAN,
        GETHRPAYROLLLOANSCHEDULEINFO,
        ISSUEHRPAYROLLLOANISSUE,
        GETHRPAYROLLLOANISSUE,
        CREATEHRPAYROLLLOANISSUE,
        UPDATEHRPAYROLLLOANISSUE,
        DELETEHRPAYROLLLOANISSUE,
        SENDHRCUSTOMTEMPEMAIL,
        GETHRPAYYROLLACCURE,
        CREATEHRPAYYROLLACCURE,
        REVERTHRPAYYROLLACCURE,
        UPDATEHRPAYYROLLACCURE,
        DELETEHRPAYYROLLACCURE,
        CLEAR_HR_STAFF,
        GETHRASSETSALL,
        CREATEHRASSETSALL,
        UPDATEHRASSETSALL,
        DELETEHRASSETSALL,
        GETHRRECRUITMENTSHIFTREQUESTS,
        CREATEHRRECRUITMENTSHIFTREQUESTS,
        UPDATEHRRECRUITMENTSHIFTREQUESTS,
        DELETEHRRECRUITMENTSHIFTREQUESTS,
        GETHRRECRUITMENTPERFORMANCEOBJECTIVE,
        CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE,
        UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE,
        DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE,
        GETHRRECRUITMENTPERFORMANCEMEETINGS,
        CREATEHRRECRUITMENTPERFORMANCEMEETINGS,
        UPDATEHRRECRUITMENTPERFORMANCEMEETINGS,
        DELETEHRRECRUITMENTPERFORMANCEMEETINGS,
        GETHRRECRUITMENTPERFORMANCEKRA,
        CREATEHRRECRUITMENTPERFORMANCEKRA,
        UPDATEHRRECRUITMENTPERFORMANCEKRA,
        DELETEHRRECRUITMENTPERFORMANCEKRA,
        GETHRRECRUITMENTPERFORMANCEQA,
        CREATEHRRECRUITMENTPERFORMANCEQA,
        UPDATEHRRECRUITMENTPERFORMANCEQA,
        DELETEHRRECRUITMENTPERFORMANCEQA,

        GETHREMAIL,
        CREATEHREMAIL,
        UPDATEHREMAIL,
        DELETEHREMAIL,
        GETHRRECRUITMENTMASTERTASK,
        CREATEHRRECRUITMENTMASTERTASK,
        UPDATEHRRECRUITMENTMASTERTASK,
        DELETEHRRECRUITMENTMASTERTASK,
        GETHRRECRUITMENTSURVEYRESPONSE,
        CREATEHRRECRUITMENTSURVEYRESPONSE,
        UPDATEHRRECRUITMENTSURVEYRESPONSE,
        DELETEHRRECRUITMENTSURVEYRESPONSE,
        GETHRRECRUITMENTPIPELINESKILLZONE,
        CREATEHRRECRUITMENTPIPELINESKILLZONE,
        UPDATEHRRECRUITMENTPIPELINESKILLZONE,
        DELETEHRRECRUITMENTPIPELINESKILLZONE,
        GETHRRECRUITMENTCANDIDATERESUME,
        CREATEHRRECRUITMENTCANDIDATERESUME,
        UPDATEHRRECRUITMENTCANDIDATERESUME,
        DELETEHRRECRUITMENTCANDIDATERESUME,
        GETHRRECRUITMENTINFO,
        CREATEHRRECRUITMENTINFO,
        UPDATEHRRECRUITMENTINFO,
        DELETEHRRECRUITMENTINFO,
        GETHRRECRUITMENTINFOHISTORY,
        CREATEHRRECRUITMENTINFOHISTORY,
        UPDATEHRRECRUITMENTINFOHISTORY,
        DELETEHRRECRUITMENTINFOHISTORY,
        GETHRRECRUITMENTCANDIDATENOTE,
        CREATEHRRECRUITMENTCANDIDATENOTE,
        UPDATEHRRECRUITMENTCANDIDATENOTE,
        DELETEHRRECRUITMENTCANDIDATENOTE,
        GETHRRECRUITMENTCANDIDATEEMAIL,
        CREATEHRRECRUITMENTCANDIDATEEMAIL,
        UPDATEHRRECRUITMENTCANDIDATEEMAIL,
        DELETEHRRECRUITMENTCANDIDATEEMAIL,
        GETHRRECRUITMENTCANDIDATE,
        CREATEHRRECRUITMENTCANDIDATE,
        UPDATEHRRECRUITMENTCANDIDATE,
        DELETEHRRECRUITMENTCANDIDATE,
        GETHRRECRUITMENTPIPELINE,
        CREATEHRRECRUITMENTPIPELINE,
        UPDATEHRRECRUITMENTPIPELINE,
        DELETEHRRECRUITMENTPIPELINE,
        GETHRRECRUITMENTSKILLZONE,
        CREATEHRRECRUITMENTSKILLZONE,
        UPDATEHRRECRUITMENTSKILLZONE,
        DELETEHRRECRUITMENTSKILLZONE,
        GETHRRECRUITMENTSTAGES,
        CREATEHRRECRUITMENTSTAGES,
        UPDATEHRRECRUITMENTSTAGES,
        DELETEHRRECRUITMENTSTAGES,
        GETHRRECRUITMENTMAIN,
        CREATEHRRECRUITMENTMAIN,
        UPDATEHRRECRUITMENTMAIN,
        DELETEHRRECRUITMENTMAIN,
        GETHRPAYROLLEARNINGDEDUCTION,
        CREATEHRPAYROLLEARNINGDEDUCTION,
        UPDATEHRPAYROLLEARNINGDEDUCTION,
        DELETEHRPAYROLLEARNINGDEDUCTION,
        CREATEHRSTAFFBANKINFORMATION,
        CREATEHRSTAFFBASICINFORMATION,
        CREATEHRSTAFFDOCUMENTINFORMATION,
        CREATEHRSTAFFLEAVEINFORMATION,
        CREATEHRSTAFFMEDIAINFORMATION,
        CREATEHRSTAFFPAYROLLINFORMATION,
        DELETEHRSTAFFBANKINFORMATION,
        DELETEHRSTAFFBASICINFORMATIONEVERYTHING,
        DELETEHRSTAFFBASICINFORMATION,
        DELETEHRSTAFFDOCUMENTINFORMATION,
        DELETEHRSTAFFLEAVEINFORMATION,
        DELETEHRSTAFFMEDIAINFORMATION,
        DELETEHRSTAFFPAYROLLINFORMATION,
        GETHRSTAFFBANKINFORMATION,
        GETHRSTAFFBANKINFORMATIONBYID,
        GETHRSTAFFBASICINFORMATION,
        GETHRSTAFFBASICINFORMATIONBYID,
        GETHRSTAFFBASICINFORMATIONBYROLL,
        GETHRSTAFFDOCUMENTINFORMATION,
        GETHRSTAFFDOCUMENTINFORMATIONBYID,
        GETHRSTAFFLEAVEINFORMATION,
        GETHRSTAFFLEAVEINFORMATIONBYID,
        GETHRSTAFFMEDIAINFORMATION,
        GETHRSTAFFMEDIAINFORMATIONBYID,
        GETHRSTAFFPAYROLLINFORMATION,
        GETHRSTAFFPAYROLLINFORMATIONBYID,
        UPDATEHRSTAFFBANKINFORMATION,
        UPDATEHRSTAFFBASICINFORMATION,
        UPDATEHRSTAFFBASICINFORMATION1,
        UPDATEHRSTAFFDOCUMENTINFORMATION,
        UPDATEHRSTAFFLEAVEINFORMATION,
        UPDATEHRSTAFFMEDIAINFORMATION,
        UPDATEHRSTAFFPAYROLLINFORMATION,
        UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES,
        GETHRRECRUITMENTPOLICIES,
        CREATEHRRECRUITMENTPOLICIES,
        UPDATEHRRECRUITMENTPOLICIES,
        DELETEHRRECRUITMENTPOLICIES,
        GETHROFFBOARDRESIGNATION,
        CREATEHROFFBOARDRESIGNATION,
        UPDATEHROFFBOARDRESIGNATION,
        DELETEHROFFBOARDRESIGNATION,
        GETHRASSETSLIST,
        CREATEHRASSETSLIST,
        UPDATEHRASSETSLIST,
        DELETEHRASSETSLIST,
        CREATEHRPAYYROLLPAYOUT,
        GETGENERALCOMPLAINTADDICTIONS,
        HRLOANGENERATEMANDATE,
} from '../actions/types';

const initialState = {
        hrstaffbasicinformationList: [],
        HRSetupAccessControlListList: [],
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

        switch (action.type) {
                case CREATEHRSTAFFBASICINFORMATION:
                        return {
                                ...state,
                                hrstaffbasicinformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFBASICINFORMATION:
                        return {
                                ...state,
                                hrstaffbasicinformationList: action.payload.data,
                        }
                case GETHRSTAFFBASICINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffbasicinformationbyidList: action.payload.data,
                        }
                case GETHRSTAFFBASICINFORMATIONBYROLL:
                        return {
                                ...state,
                                hrstaffbasicinformationbyrollList: action.payload.data,
                        }
                case UPDATEHRSTAFFBASICINFORMATION:
                        return {
                                ...state,
                                hrstaffbasicinformationUpdateStatus: action.payload.success,
                        }
                case UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES:
                        return {
                                ...state,
                                hrstaffbasicinformationForalltablesUpdateStatus: action.payload.success,
                        }
                case UPDATEHRSTAFFBASICINFORMATION1:
                        return {
                                ...state,
                                hrstaffbasicinformationUpdateStatus1: action.payload.success,
                        }

                case DELETEHRSTAFFBASICINFORMATION:
                        return {
                                ...state,
                                hrstaffbasicinformationDeleteStatus: action.payload.success,
                        }
                case DELETEHRSTAFFBASICINFORMATIONEVERYTHING:
                        return {
                                ...state,
                                hrstaffbasicinformationEverythingDeleteStatus: action.payload.success,
                        }
                case CREATEHRSTAFFPAYROLLINFORMATION:
                        return {
                                ...state,
                                hrstaffpayrollinformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFPAYROLLINFORMATION:
                        return {
                                ...state,
                                hrstaffpayrollinformationList: action.payload.data,
                        }
                case GETHRSTAFFPAYROLLINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffpayrollinformationbyidList: action.payload.data,
                        }
                case UPDATEHRSTAFFPAYROLLINFORMATION:
                        return {
                                ...state,
                                hrstaffpayrollinformationUpdateStatus: action.payload.success,
                        }

                case DELETEHRSTAFFPAYROLLINFORMATION:
                        return {
                                ...state,
                                hrstaffleaveinformationDeleteStatus: action.payload.success,
                        }
                case CREATEHRSTAFFLEAVEINFORMATION:
                        return {
                                ...state,
                                hrstaffleaveinformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFLEAVEINFORMATION:
                        return {
                                ...state,
                                hrstaffleaveinformationList: action.payload.data,
                        }
                case GETHRSTAFFLEAVEINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffleaveinformationbyidList: action.payload.data,
                        }
                case UPDATEHRSTAFFLEAVEINFORMATION:
                        return {
                                ...state,
                                hrstaffleaveinformationUpdateStatus: action.payload.success,
                        }

                case DELETEHRSTAFFLEAVEINFORMATION:
                        return {
                                ...state,
                                hrstaffleaveinformationDeleteStatus: action.payload.success,
                        }
                case CREATEHRSTAFFBANKINFORMATION:
                        return {
                                ...state,
                                hrstaffbankinformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFBANKINFORMATION:
                        return {
                                ...state,
                                hrstaffbankinformationList: action.payload.data,
                        }
                case GETHRSTAFFBANKINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffbankinformationbyidList: action.payload.data,
                        }
                case UPDATEHRSTAFFBANKINFORMATION:
                        return {
                                ...state,
                                hrstaffbankinformationUpdateStatus: action.payload.success,
                        }

                case DELETEHRSTAFFBANKINFORMATION:
                        return {
                                ...state,
                                hrstaffbankinformationDeleteStatus: action.payload.success,
                        }
                case CREATEHRSTAFFMEDIAINFORMATION:
                        return {
                                ...state,
                                hrstaffmediainformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFMEDIAINFORMATION:
                        return {
                                ...state,
                                hrstaffmediainformationList: action.payload.data,
                        }
                case GETHRSTAFFMEDIAINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffmediainformationbyidList: action.payload.data,
                        }
                case UPDATEHRSTAFFMEDIAINFORMATION:
                        return {
                                ...state,
                                hrstaffmediainformationUpdateStatus: action.payload.success,
                        }

                case DELETEHRSTAFFMEDIAINFORMATION:
                        return {
                                ...state,
                                hrstaffmediainformationDeleteStatus: action.payload.success,
                        }
                case CREATEHRSTAFFDOCUMENTINFORMATION:
                        return {
                                ...state,
                                hrstaffdocumentinformationSaveStatus: action.payload.success,
                        }
                case GETHRSTAFFDOCUMENTINFORMATION:
                        return {
                                ...state,
                                hrstaffdocumentinformationList: action.payload.data,
                        }
                case GETHRSTAFFDOCUMENTINFORMATIONBYID:
                        return {
                                ...state,
                                hrstaffdocumentinformationbyidList: action.payload.data,
                        }
                case UPDATEHRSTAFFDOCUMENTINFORMATION:
                        return {
                                ...state,
                                hrstaffdocumentinformationUpdateStatus: action.payload.success,
                        }

                case DELETEHRSTAFFDOCUMENTINFORMATION:
                        return {
                                ...state,
                                hrstaffdocumentinformationDeleteStatus: action.payload.success,
                        }

                case GETHRPAYROLLEARNINGDEDUCTION: return { ...state, HRPayrollEarningDeductionList: action.payload.data, }
                case CREATEHRPAYROLLEARNINGDEDUCTION: return { ...state, HRPayrollEarningDeductionSaveStatus: action.payload.success, }
                case UPDATEHRPAYROLLEARNINGDEDUCTION: return { ...state, HRPayrollEarningDeductionUpdateStatus: action.payload.success, }
                case DELETEHRPAYROLLEARNINGDEDUCTION: return { ...state, HRPayrollEarningDeductionDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTSKILLZONE: return { ...state, HRRecruitmentSkillZoneList: action.payload.data, }
                case CREATEHRRECRUITMENTSKILLZONE: return { ...state, HRRecruitmentSkillZoneSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTSKILLZONE: return { ...state, HRRecruitmentSkillZoneUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTSKILLZONE: return { ...state, HRRecruitmentSkillZoneDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTSTAGES: return { ...state, HRRecruitmentStagesList: action.payload.data, }
                case GETHRRECRUITMENTSTAGESBYID: return { ...state, HRRecruitmentStagesByIdList: action.payload.data, }
                case GETHRRECRUITMENTSTAGESALLDETAILS: return { ...state, HRRecruitmentStagesAllDetailsList: action.payload.data, }
                case CREATEHRRECRUITMENTSTAGES: return { ...state, HRRecruitmentStagesSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTSTAGES: return { ...state, HRRecruitmentStagesUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTSTAGES: return { ...state, HRRecruitmentStagesDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTMAIN: return { ...state, HRRecruitmentMainList: action.payload.data, }
                case CREATEHRRECRUITMENTMAIN: return { ...state, HRRecruitmentMainSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTMAIN: return { ...state, HRRecruitmentMainUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTMAIN: return { ...state, HRRecruitmentMainDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTCANDIDATE: return { ...state, HRRecruitmentCandidateList: action.payload.data, }
                case CREATEHRRECRUITMENTCANDIDATE: return { ...state, HRRecruitmentCandidateSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTCANDIDATE: return { ...state, HRRecruitmentCandidateUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTCANDIDATE: return { ...state, HRRecruitmentCandidateDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTPIPELINE: return { ...state, HRRecruitmentPipelineList: action.payload.data, }
                case CREATEHRRECRUITMENTPIPELINE: return { ...state, HRRecruitmentPipelineSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPIPELINE: return { ...state, HRRecruitmentPipelineUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPIPELINE: return { ...state, HRRecruitmentPipelineDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTCANDIDATERESUME: return { ...state, HRRecruitmentCandidateResumeList: action.payload.data, }
                case CREATEHRRECRUITMENTCANDIDATERESUME: return { ...state, HRRecruitmentCandidateResumeSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTCANDIDATERESUME: return { ...state, HRRecruitmentCandidateResumeUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTCANDIDATERESUME: return { ...state, HRRecruitmentCandidateResumeDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTINFO: return { ...state, HRRecruitmentInfoList: action.payload.data, }
                case GETHRRECRUITMENTINFOBYID: return { ...state, HRRecruitmentInfoByIdList: action.payload.data, }
                case CREATEHRRECRUITMENTINFO: return { ...state, HRRecruitmentInfoSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTINFO: return { ...state, HRRecruitmentInfoUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTINFO: return { ...state, HRRecruitmentInfoDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTINFOHISTORY: return { ...state, HRRecruitmentInfoHistoryList: action.payload.data, }
                case GETHRRECRUITMENTINFOHISTORYBYID: return { ...state, HRRecruitmentInfoHistoryByIdList: action.payload.data, }
                case GETHRRECRUITMENTINFOHISTORYALLDETAILS: return { ...state, HRRecruitmentInfoHistoryAllDetailsList: action.payload.data, }
                case CREATEHRRECRUITMENTINFOHISTORY: return { ...state, HRRecruitmentInfoHistorySaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTINFOHISTORY: return { ...state, HRRecruitmentInfoHistoryUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTINFOHISTORY: return { ...state, HRRecruitmentInfoHistoryDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTCANDIDATENOTE: return { ...state, HRRecruitmentCandidateNoteList: action.payload.data, }
                case CREATEHRRECRUITMENTCANDIDATENOTE: return { ...state, HRRecruitmentCandidateNoteSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTCANDIDATENOTE: return { ...state, HRRecruitmentCandidateNoteUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTCANDIDATENOTE: return { ...state, HRRecruitmentCandidateNoteDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTCANDIDATEEMAIL: return { ...state, HRRecruitmentCandidateEmailList: action.payload.data, }
                case CREATEHRRECRUITMENTCANDIDATEEMAIL: return { ...state, HRRecruitmentCandidateEmailSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTCANDIDATEEMAIL: return { ...state, HRRecruitmentCandidateEmailUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTCANDIDATEEMAIL: return { ...state, HRRecruitmentCandidateEmailDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTPIPELINESKILLZONE: return { ...state, HRRecruitmentPipelineSkillZoneList: action.payload.data, }
                case CREATEHRRECRUITMENTPIPELINESKILLZONE: return { ...state, HRRecruitmentPipelineSkillZoneSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPIPELINESKILLZONE: return { ...state, HRRecruitmentPipelineSkillZoneUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPIPELINESKILLZONE: return { ...state, HRRecruitmentPipelineSkillZoneDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTSURVEYRESPONSE: return { ...state, HRRecruitmentSurveyResponseList: action.payload.data, }
                case CREATEHRRECRUITMENTSURVEYRESPONSE: return { ...state, HRRecruitmentSurveyResponseSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTSURVEYRESPONSE: return { ...state, HRRecruitmentSurveyResponseUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTSURVEYRESPONSE: return { ...state, HRRecruitmentSurveyResponseDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTMASTERTASK: return { ...state, HRRecruitmentHrMasterTaskList: action.payload.data, }
                case CREATEHRRECRUITMENTMASTERTASK: return { ...state, HRRecruitmentHrMasterTaskSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTMASTERTASK: return { ...state, HRRecruitmentHrMasterTaskUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTMASTERTASK: return { ...state, HRRecruitmentHrMasterTaskDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTPOLICIES: return { ...state, HRRecruitmentHrPoliciesList: action.payload.data, }
                case CREATEHRRECRUITMENTPOLICIES: return { ...state, HRRecruitmentHrPoliciesSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPOLICIES: return { ...state, HRRecruitmentHrPoliciesUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPOLICIES: return { ...state, HRRecruitmentHrPoliciesDeleteStatus: action.payload.success, }
                case GETHRRECRUITMENTSHIFTREQUESTS: return {
                        ...state,
                        //  HRRecruitmentShiftRequestsList: action.payload.data,
                        HRRecruitmentShiftRequestsList: action.payload.data || [],
                }
                case CREATEHRRECRUITMENTSHIFTREQUESTS: return { ...state, HRRecruitmentShiftRequestsSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTSHIFTREQUESTS: return { ...state, HRRecruitmentShiftRequestsUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTSHIFTREQUESTS: return { ...state, HRRecruitmentShiftRequestsDeleteStatus: action.payload.success, }

                case GETHREMAIL: return { ...state, HREmailList: action.payload.data, }
                case CREATEHREMAIL: return { ...state, HREmailSaveStatus: action.payload.success, }
                case SENDHRSMS: return { ...state, HRSMSList: action.payload.success, }
                case UPDATEHREMAIL: return { ...state, HREmailUpdateStatus: action.payload.success, }
                case DELETEHREMAIL: return { ...state, HREmailDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTPERFORMANCEOBJECTIVE: return { ...state, HRRecruitmentPerformanceObjectiveList: action.payload.data, }
                case CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE: return { ...state, HRRecruitmentPerformanceObjectiveSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE: return { ...state, HRRecruitmentPerformanceObjectiveUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE: return { ...state, HRRecruitmentPerformanceObjectiveDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTPERFORMANCEMEETINGS: return { ...state, HRRecruitmentPerformanceMeetingsList: action.payload.data, }
                case CREATEHRRECRUITMENTPERFORMANCEMEETINGS: return { ...state, HRRecruitmentPerformanceMeetingsSaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPERFORMANCEMEETINGS: return { ...state, HRRecruitmentPerformanceMeetingsUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPERFORMANCEMEETINGS: return { ...state, HRRecruitmentPerformanceMeetingsDeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTPERFORMANCEKRA: return { ...state, HRRecruitmentPerformanceKRAList: action.payload.data, }
                case CREATEHRRECRUITMENTPERFORMANCEKRA: return { ...state, HRRecruitmentPerformanceKRASaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPERFORMANCEKRA: return { ...state, HRRecruitmentPerformanceKRAUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPERFORMANCEKRA: return { ...state, HRRecruitmentPerformanceKRADeleteStatus: action.payload.success, }

                case GETHRRECRUITMENTPERFORMANCEQA: return { ...state, HRRecruitmentPerformanceQAList: action.payload.data, }
                case CREATEHRRECRUITMENTPERFORMANCEQA: return { ...state, HRRecruitmentPerformanceQASaveStatus: action.payload.success, }
                case UPDATEHRRECRUITMENTPERFORMANCEQA: return { ...state, HRRecruitmentPerformanceQAUpdateStatus: action.payload.success, }
                case DELETEHRRECRUITMENTPERFORMANCEQA: return { ...state, HRRecruitmentPerformanceQADeleteStatus: action.payload.success, }

                case GETHROFFBOARDRESIGNATION: return { ...state, HROffboardResignationList: action.payload.data, }
                case CREATEHROFFBOARDRESIGNATION: return { ...state, HROffboardResignationSaveStatus: action.payload.success, }
                case UPDATEHROFFBOARDRESIGNATION: return { ...state, HROffboardResignationUpdateStatus: action.payload.success, }
                case DELETEHROFFBOARDRESIGNATION: return { ...state, HROffboardResignationDeleteStatus: action.payload.success, }

                case GETHRASSETSALL: return { ...state, HRAssetsAllAssetsList: action.payload.data, }
                case CREATEHRASSETSALL: return { ...state, HRAssetsAllAssetsSaveStatus: action.payload.success, }
                case UPDATEHRASSETSALL: return { ...state, HRAssetsAllAssetsUpdateStatus: action.payload.success, }
                case DELETEHRASSETSALL: return { ...state, HRAssetsAllAssetsDeleteStatus: action.payload.success, }
                case GETHRASSETSLIST: return { ...state, HRAssetsListAssetsList: action.payload.data, }
                case CREATEHRASSETSLIST: return { ...state, HRAssetsListAssetsSaveStatus: action.payload.success, }
                case UPDATEHRASSETSLIST: return { ...state, HRAssetsListAssetsUpdateStatus: action.payload.success, }
                case DELETEHRASSETSLIST: return { ...state, HRAssetsListAssetsDeleteStatus: action.payload.success, }

                case CREATEHRPAYYROLLACCURE: return { ...state, HRPayrollAccureSaveStatus: action.payload.success, }
                case REVERTHRPAYYROLLACCURE: return { ...state, HRPayrollAccureRevertStatus: action.payload.success, }
                case UPDATEHRPAYYROLLACCURE: return { ...state, HRPayrollAccureUpdateStatus: action.payload.success, }
                case CREATEHRPAYYROLLPAYOUT: return { ...state, HRPayrollPayoutSaveStatus: action.payload.success, }
                case INITIATELOANHRPAYOUT: return { ...state, InitiateLoanHRPayrollPayoutSaveStatus: action.payload.success, }
                case SENDHRCUSTOMTEMPEMAIL: return { ...state, HRCustomNotificationEmailSaveStatus: action.payload.success, }

                case GETHRPAYROLLLOANISSUE: return { ...state, HRPayrollIssueLoanList: action.payload.data, }
                case CREATEHRPAYROLLLOANISSUE: return { ...state, HRPayrollIssueLoanSaveStatus: action.payload.success, }
                case ISSUEHRPAYROLLLOANISSUE: return { ...state, HRPayrollIssueLoanIssueSaveStatus: action.payload.success, }
                case UPDATEHRPAYROLLLOANISSUE: return { ...state, HRPayrollIssueLoanUpdateStatus: action.payload.success, }
                case DELETEHRPAYROLLLOANISSUE: return { ...state, HRPayrollIssueLoanDeleteStatus: action.payload.success, }

                case GET_HR_STAFF_LOAN_REQUESTS:
                        return {
                                ...state,
                                loanRequestsList: action.payload || []
                        };
                case GET_HR_STAFF_LOAN_REQUEST_DETAILS:
                        return {
                                ...state,
                                selectedRequestDetails: action.payload || null
                        };
                case HRLOANGENERATEMANDATE:
                        return {
                                ...state,
                                GenerateMandateDetails: action.payload || []
                        };

                case GETHRPAYROLLLOANSCHEDULEINFO: return { ...state, HRPayrollLoanScheduleInfoList: action.payload.data, }
                case CREATEHRPAYROLLLOANADDONINTERESTLOAN: return { ...state, HRPayrollLoanAddOnInterestSaveStatus: action.payload.success, }
                case CREATEHRPAYROLLLOANPREPAYPPARTIAL: return { ...state, HRPayrollLoanRepayPartialSaveStatus: action.payload.success, }
                case CREATEHRPAYROLLLOANPREPAYFULL: return { ...state, HRPayrollLoanRepayFullSaveStatus: action.payload.success, }
                case CREATEHRPAYROLLLOANREPAYPAYROLL: return { ...state, HRPayrollLoanRepayPayrollSaveStatus: action.payload.success, }
                case CREATEHRPAYROLLLOANREPAYMANUAL: return { ...state, HRPayrollLoanRepayManualSaveStatus: action.payload.success, }

                case GETHRLOANDOCUMENTS: return { ...state, HRLoanDocumentsList: action.payload.data, }
                case CREATEHRLOANDOCUMENTS: return { ...state, HRLoanDocumentsSaveStatus: action.payload.success, }
                case UPDATEHRLOANDOCUMENTS: return { ...state, HRLoanDocumentsUpdateStatus: action.payload.success, }
                case DELETEHRLOANDOCUMENTS: return { ...state, HRLoanDocumentsDeleteStatus: action.payload.success, }
                case GETHRLOANPOLICYINFOHISTORY: return { ...state, HRLoanPolicyInfoHistoryList: action.payload.data, }
                case CREATEHRLOANPOLICYINFOHISTORY: return { ...state, HRLoanPolicyInfoHistorySaveStatus: action.payload.success, }
                case UPDATEHRLOANPOLICYINFOHISTORY: return { ...state, HRLoanPolicyInfoHistoryUpdateStatus: action.payload.success, }
                case DELETEHRLOANPOLICYINFOHISTORY: return { ...state, HRLoanPolicyInfoHistoryDeleteStatus: action.payload.success, }

                case GETHRSETUPACLLIST: return { ...state, HRSetupAccessControlListList: action.payload.data, }
                case CREATEHRSETUPACLLIST: return { ...state, HRSetupAccessControlListSaveStatus: action.payload.success, }
                case UPDATEHRSETUPACLLIST: return { ...state, HRSetupAccessControlListUpdateStatus: action.payload.success, }
                case DELETEHRSETUPACLLIST: return { ...state, HRSetupAccessControlListDeleteStatus: action.payload.success, }

                // training history setup
                case GETHRTRAININGHISTORY: return { ...state, HRTrainingHistoryList: action.payload.data, }
                case GETHRTRAININGHISTORYBYID: return { ...state, HRTrainingHistoryByIdList: action.payload.data, }
                case GETHRTRAININGHISTORYALLDETAILS: return { ...state, HRTrainingHistoryAllDetailsList: action.payload.data, }
                case CREATEHRTRAININGHISTORY: return { ...state, HRTrainingHistorySaveStatus: action.payload.success, }
                case UPDATEHRTRAININGHISTORY: return { ...state, HRTrainingHistoryUpdateStatus: action.payload.success, }
                case DELETEHRTRAININGHISTORY: return { ...state, HRTrainingHistoryDeleteStatus: action.payload.success, }




                case CLEAR_HR_STAFF:
                        return {
                                ...state,
                                hrstaffbasicinformationList: []
                        };

                case CLEAR_HR_RECPIPELINE: return { ...state, HRRecruitmentPipelineList: [] };
                case CLEAR_HR_SETUPACL: return { ...state, HRSetupAccessControlListList: [] };
                case CLEAR_HRINFOHISTORY: return { ...state, HRRecruitmentInfoHistoryList: [] };
                case CLEAR_HRINFO: return { ...state, HRRecruitmentInfoList: [] };

                default:
                        return state
        }
}